import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface ModalDefaultType {
  pageName: string;
  setPageName: (page) => void;
  templateID: (template) => void;
}

function Template({ pageName, setPageName, templateID }: PropsWithChildren<ModalDefaultType>) {
  const [template, setTemplate] = useState<string>('');
  const [page, setPage] = useState<string>('');

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes('/en/')) {
      if (pageName === 'constructionSafety') {
        setTemplate('template_6pik76u');
      } else if (pageName === 'constructionAsset') {
        setTemplate('template_m9rsl2h');
      } else if (pageName === 'constructionEquipment') {
        setTemplate('template_wo7rjxq');
      } else if (pageName === 'logisticsAsset') {
        setTemplate('template_6h38j6j');
      } else if (pageName === 'logisticsSafety') {
        setTemplate('template_egexens');
      } else if (pageName === 'retailOffice') {
        setTemplate('template_xiqotee');
      } else if (pageName === 'manufacturingProcess') {
        setTemplate('template_gql1ywo');
      } else if (pageName === 'manufacturingSteel') {
        setTemplate('template_bil9dsn');
      } else if (pageName === 'medicalPatient') {
        setTemplate('template_961u37a');
      } else if (pageName === 'medicalWaste') {
        setTemplate('template_olc7oyb');
      } else if (pageName === 'retailExhibition') {
        setTemplate('template_63selv8');
      }
    } else if (location.pathname.includes('/jp/')) {
      if (pageName === 'constructionSafety') {
        setTemplate('template_r7bc2ov');
      } else if (pageName === 'constructionAsset') {
        setTemplate('template_cfokcmt');
      } else if (pageName === 'constructionEquipment') {
        setTemplate('template_mlajmsa');
      } else if (pageName === 'logisticsAsset') {
        setTemplate('template_01wnr0l');
      } else if (pageName === 'logisticsSafety') {
        setTemplate('template_bqpso5l');
      } else if (pageName === 'retailOffice') {
        setTemplate('template_mu8kyxl');
      } else if (pageName === 'manufacturingProcess') {
        setTemplate('template_3v29n7l');
      } else if (pageName === 'manufacturingSteel') {
        setTemplate('template_7nl7lks');
      } else if (pageName === 'medicalPatient') {
        setTemplate('template_nslnrd5');
      } else if (pageName === 'medicalWaste') {
        setTemplate('template_haexsui');
      } else if (pageName === 'retailExhibition') {
        setTemplate('template_zgd1y4h');
      }
    } else {
      console.log(pageName);
      console.log(pageName);
      // 한국 버전
      if (pageName === 'constructionSafety') {
        setTemplate('template_ueakes4');
      } else if (pageName === 'constructionSop') {
        setTemplate('template_xgm0808');
      } else if (pageName === 'constructionEquipment') {
        setTemplate('template_gp95u4m');
      } else if (pageName === 'retailMobile') {
        setTemplate('template_7jsqa9s');
      } else if (pageName === 'retailExhibition') {
        setTemplate('template_r7qfz0i');
      } else if (pageName === 'retailOffice') {
        setTemplate('template_2vpi1le');
      } else if (pageName === 'cityDigital') {
        setTemplate('template_0kol76j');
      } else if (pageName === 'publicSafety') {
        setTemplate('template_l0u5d45');
      } else if (pageName === 'digitaltwin') {
        setTemplate('template_s6wirzz');
      } else if (pageName === 'publicCrosswalk') {
        setTemplate('template_ndw4l38');
      } else if (pageName === 'cityTraffic') {
        setTemplate('template_psu3ppr');
      } else if (pageName === 'publicTraining') {
        setTemplate('template_vdmlwx7');
      } else if (pageName === 'manufacturingSteel') {
        setTemplate('template_jwcox44');
      } else if (pageName === 'manufacturingForklift') {
        setTemplate('template_lmm3pvy');
      } else if (pageName === 'manufacturingProcess') {
        setTemplate('template_1bpj5ce');
      } else if (pageName === 'logisticsManage') {
        setTemplate('template_kxyv6yx');
      } else if (pageName === 'logisticsAsset') {
        setTemplate('template_i6som1m');
      } else if (pageName === 'medicalPatient') {
        setTemplate('template_hm2ilts');
      } else if (pageName === 'medicalWaste') {
        setTemplate('template_vaa1z25');
      } else if (pageName === 'educationSafety') {
        setTemplate('template_156gzqa');
      }

      // 과거 버전
      // if (pageName === 'constructionSafety') {
      //   setTemplate('template_7tgxod8');
      // } else if (pageName === 'constructionAsset') {
      //   setTemplate('template_2jki8c7');
      // } else if (pageName === 'constructionEquipment') {
      //   setTemplate('template_8o6dndr');
      // } else if (pageName === 'logisticsAsset') {
      //   setTemplate('template_vfs96xr');
      // } else if (pageName === 'logisticsSafety') {
      //   setTemplate('template_ipnhreh');
      // } else if (pageName === 'retailOffice') {
      //   setTemplate('template_v7u5yf9');
      // } else if (pageName === 'manufacturingProcess') {
      //   setTemplate('template_51a2a6c');
      // } else if (pageName === 'manufacturingSteel') {
      //   setTemplate('template_pufv8li');
      // } else if (pageName === 'medicalPatient') {
      //   setTemplate('template_8i04xgh');
      // } else if (pageName === 'medicalWaste') {
      //   setTemplate('template_2ohm2nm');
      // } else if (pageName === 'retailExhibition') {
      //   setTemplate('template_o0a2d6a');
      // }
    }

    templateID(template);
  });

  useEffect(() => {
    if (pageName === 'constructionSafety') {
      setPage('건설 작업자 안전관리');
    } else if (pageName === 'constructionSop') {
      setPage('건설 표준작업 절차 관리');
    } else if (pageName === 'constructionAsset') {
      setPage('건설자재 위치 추적');
    } else if (pageName === 'constructionEquipment') {
      setPage('건설 중장비 관리');
    } else if (pageName === 'logisticsAsset') {
      setPage('물류 재고 위치 추적');
    } else if (pageName === 'logisticsSafety') {
      setPage('물류 창고 작업자 안전관리');
    } else if (pageName === 'logisticsManage') {
      setPage('물류 출입 및 자산 통합 관리');
    } else if (pageName === 'retailOffice') {
      setPage('오피스 자산관리');
    } else if (pageName === 'retailMobile') {
      setPage('리테일 모바일 고객 행동 분석');
    } else if (pageName === 'retailExhibition') {
      setPage('리테일 전시관 방문객 분석');
    } else if (pageName === 'manufacturingProcess') {
      setPage('제조 실시간 공정 관리');
    } else if (pageName === 'manufacturingSteel') {
      setPage('제조 실시간 재고 관리');
    } else if (pageName === 'manufacturingForklift') {
      setPage('제조 지게차 안전관리');
    } else if (pageName === 'medicalPatient') {
      setPage('의료 환자 위치 추적');
    } else if (pageName === 'medicalWaste') {
      setPage('의료 폐기물 관리');
    } else if (pageName === 'cityDigital') {
      setPage('디지털 트윈 도시 통합 플랫폼');
    } else if (pageName === 'cityTraffic') {
      setPage('스마트 도시 교통 흐름 분석');
    } else if (pageName === 'publicCrosswalk') {
      setPage('횡단보도 위험 감지 시스템');
    } else if (pageName === 'publicSafety') {
      setPage('공공시설 안전관리');
    } else if (pageName === 'publicTraining') {
      setPage('공공기관 훈련 시나리오 분석');
    } else if (pageName === 'digitaltwin') {
      setPage('디지털트윈 기반 통합 관제');
    } else if (pageName === 'educationSafety') {
      setPage('교육기관 출입 및 안전관리');
    }

    setPageName(page);
  });

  return <></>;
}

export default Template;
